/**
 *
 * Asynchronously loads the component for ContactUsEnquiry
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ContactUsEnquiry = lazyLoad(() => import('./index'));
